import { cloneDeep } from 'lodash'
import { format } from 'date-fns'
import pluralize from 'pluralize'

import { CHART } from '@/components/charts/chartPalette'

const SUMMARY_BAR_CHART = {
  xAxis: {
    data: [],
    show: false,
  },
  yAxis: { show: false },
  tooltip: {
    trigger: 'axis',
    backgroundColor: 'var(--color-background-inverse)',
    textStyle: {
      color: 'var(--color-text-on-fill)',
    },
    axisPointer: {
      // Use axis to trigger tooltip
      type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
    },
    formatter: (params) => {
      const { name, data } = params[0]
      return `${name} - ${data} ${pluralize('Note', data)}`
    },
  },
  series: [
    {
      type: 'bar',
      data: [],
      itemStyle: {
        borderRadius: [30, 30, 0, 0],
      },
      emphasis: {
        focus: 'series',
        itemStyle: {},
      },
    },
  ],
  grid: { left: '0', right: '0', bottom: '0', height: '45px', containLabel: false },
}

export const getBarChartData = (summariesByDate) => {
  const data = cloneDeep(SUMMARY_BAR_CHART)
  data.series[0].itemStyle.color = CHART.BRAND_BG
  data.series[0].emphasis.itemStyle.color = CHART.BRAND
  const xAxisLabel = []
  const seriesData = []

  summariesByDate.forEach((item) => {
    // this ensures that the date is formatted as 'MMM d' (e.g. Oct 1) without accounting for TZ 🤮
    const [year, month, day] = item.summary_date.split('-')
    // month is indexed from 0
    xAxisLabel.push(format(new Date(year, Number(month) - 1, day), 'MMM d'))
    seriesData.push(item.total_summaries)
  })

  data.xAxis.data = xAxisLabel
  data.series[0].data = seriesData

  return data
}
